<template>
  <div class="main-container">
    <div class="message-container">
      <img src="../../assets/icons/warning.svg" alt="warning" />
      <h3 class="bold">
        {{ $props.errorTitle ?? t("Trouble-creating-reference") }}
      </h3>
      <p class="secondary n-margin-bottom">
        {{ $props.errorDetails ?? t("you-can-try-again") }}
      </p>
      <p v-if="contactSupportText" class="secondary">
        {{ contactSupportText }}
      </p>
    </div>
    <div class="buttons-container">
      <button class="primary" @click="tryAgainClick">
        {{ t("try-again") }}
        <img src="../../assets/icons/refresh.svg" alt="refresh" />
      </button>
      <button class="secondary" @click="tryAnotherProvider">
        {{ t("NoProviderReference-TryAnotherProviderButton") }}
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import {useI18n} from "vue-i18n";
import {AnalyticEventsNames} from "@/helpers/google-analytics.helpers";
import {useStore} from "vuex";
import { computed, defineComponent } from "vue";
import authHelper from "@/helpers/authHelper";
import {ActionLogTypeConst} from "@/types/IActionLogs";
import { ISession } from "@/types/ISession";

export default defineComponent({
  name: "NoProviderReference",
  props: {
    errorTitle: {
      type: String,
      default: undefined,
    },
    errorDetails: {
      type: String,
      default: undefined,
    },
  },
  emits: ["try-again", "try-another-payment"],
  setup(props) {
    const { t } = useI18n();
    const store = useStore();
    const country = computed(() => store.state.payOptions.deviceInfo.country);
    const deviceTag = computed(() => store.state.payOptions.deviceInfo.deviceTag);
    const contactSupportText = computed(() => {
      // TODO: Check for keys instead of values and move this validation outside.
      if (
        props.errorDetails?.includes("Error en el dominio del correo") ||
        props.errorDetails?.includes("Por motivos de seguridad no pudimos procesar tu pago")
      ) {
        return t("contact-payjoy-support-to-validate-data");
      }
      return undefined;
    });

    return {
      t,
      contactSupportText,
      country,
      deviceTag,
      store,
    };
  },
  mounted() {
    if(this.deviceTag) {
      authHelper.logAction({
        deviceTag: this.deviceTag,
        country: this.country,
        action: AnalyticEventsNames.OnErrorPage_CannotGenerateReference,
        actionType: ActionLogTypeConst.PAGE_VIEW,
      }, this.$gtag);
    }
  },
  beforeUnmount() {
    if(this.deviceTag) {
      authHelper.logAction({
        deviceTag: this.deviceTag,
        country: this.country,
        action: AnalyticEventsNames.OnErrorPage_CannotGenerateReference_TryAgain,
        actionType: ActionLogTypeConst.PAGE_VIEW,
      }, this.$gtag);
    }
  },
  methods: {
    tryAgainClick() {
      this.$emit("try-again");

      if(this.deviceTag) {
        authHelper.logAction({
          deviceTag: this.deviceTag,
          country: this.country,
          action: AnalyticEventsNames.OnErrorPage_CannotGenerateReference_TryAgain,
          actionType: ActionLogTypeConst.PAGE_VIEW,
        }, this.$gtag);

        this.$router.go(-1); // Go back to the previous page

      } else {
        const session: ISession | null = authHelper.getSession();
        if(session) {
          this.$router.push(`/p/device/${session.deviceTag}`);
        }
      }
    },
    tryAnotherProvider() {
      this.$emit("try-another-payment");

      if(this.deviceTag) {
        authHelper.logAction({
          deviceTag: this.deviceTag,
          country: this.country,
          action: AnalyticEventsNames.OnErrorPage_CannotGenerateReference_TryAnotherMethod,
          actionType: ActionLogTypeConst.PAGE_VIEW,
        }, this.$gtag);

        this.$router.push({ name: "ProvidersByDeviceTagAndCountry" });

      } else {
        const session: ISession | null = authHelper.getSession();
        if (session) {
          this.$router.push(`/p/device/${session.deviceTag}`);
        }
      }
    },
  },
});
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 32px);
  padding: 16px;
  text-align: center;
}

.message-container {
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.message-container img {
  margin: auto;
}

.buttons-container {
  margin-inline: 32px;
  width: 100%;
  gap: 12px;
  display: flex;
  flex-direction: column;
}

p.secondary.n-margin-bottom {
  margin-bottom: -32px;
}
</style>
